import {Component, Inject} from "@angular/core";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {QuestionStatus} from "../../../mapping/OfferJourneyStatusMapping";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {delay, switchMap, takeUntil, tap} from "rxjs/operators";
import {mixinDestroyable} from "fello-common";
import {of} from "rxjs";
@Component({
  selector: "app-question-card",
  templateUrl: "./question-card.component.html",
  styleUrls: ["./question-card.component.scss"]
})
export class QuestionCardComponent extends mixinDestroyable(class {}) {
  status: QuestionStatus;
  QuestionStatus = QuestionStatus;
  shrink$ = this.offerJourneyService.offerJourneyStatusMapping.pipe(
    switchMap(statusMapping => {
      if (statusMapping[this.taskId] === QuestionStatus.COMPLETE) {
        return of(true).pipe(delay(1500));
      }
      return of(false);
    })
  );

  constructor(@Inject(FELLO_JOURNEY_TASK_ID) public taskId: string, private offerJourneyService: OfferJourneyService) {
    super();
  }

  ngOnInit(): void {
    this.offerJourneyService.offerJourneyStatusMapping
      .pipe(
        takeUntil(this.isDestroyed),
        tap(statusMapping => {
          this.status = statusMapping[this.taskId];
        })
      )
      .subscribe();
  }

  editAnswer(): void {
    setTimeout(() => {
      const el = document.getElementById(this.taskId);
      if (el) el.scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"});
    }, 100);
    this.offerJourneyService.updateStatus(this.taskId, QuestionStatus.ACTIVE);
  }
}
